var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from '@horizon/base';
import { property } from '@horizon/base/decorators.js';
import ColumnStyles from './column.css.js';
/**
 *
 * @tag hzn-column
 * @tagname hzn-column
 * @summary A single column defined in hzn-columns
 */
export class HznColumn extends LitElement {
    render() {
        return html `<div class="column-cont">
      <slot></slot>
    </div>`;
    }
}
HznColumn.styles = [ColumnStyles];
__decorate([
    property({ type: String, reflect: true })
], HznColumn.prototype, "width", void 0);
//# sourceMappingURL=column.js.map